import React from 'react';
import NetworkNodes from '@/components/marketing/NetworkNodes';

/**
 * Layered premium background. Use as fixed sibling at the top of dark sections.
 * Renders subtle grid + glow orbs + network nodes + noise overlay.
 */
export default function DecorBackground({ variant = 'hero', nodes = false }) {
  return (
    <div className="absolute inset-0 -z-10 overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0 grid-pattern grid-pattern-fade opacity-70" />
      {variant === 'hero' && (
        <>
          <div className="glow-orb" style={{ top: '-12%', left: '-6%', width: '520px', height: '520px', background: 'radial-gradient(circle, rgba(34,211,238,0.45), transparent 60%)' }} />
          <div className="glow-orb" style={{ bottom: '-18%', right: '-8%', width: '620px', height: '620px', background: 'radial-gradient(circle, rgba(124,58,237,0.42), transparent 65%)' }} />
          <div className="glow-orb" style={{ top: '20%', right: '20%', width: '320px', height: '320px', background: 'radial-gradient(circle, rgba(37,99,235,0.32), transparent 60%)' }} />
        </>
      )}
      {variant === 'section' && (
        <>
          <div className="glow-orb" style={{ top: '-20%', left: '50%', transform: 'translateX(-50%)', width: '700px', height: '380px', background: 'radial-gradient(ellipse, rgba(37,99,235,0.22), transparent 65%)' }} />
          <div className="glow-orb" style={{ bottom: '-30%', right: '-10%', width: '480px', height: '480px', background: 'radial-gradient(circle, rgba(124,58,237,0.20), transparent 65%)' }} />
        </>
      )}
      {variant === 'header' && (
        <>
          <div className="glow-orb" style={{ top: '-30%', left: '10%', width: '420px', height: '320px', background: 'radial-gradient(ellipse, rgba(34,211,238,0.25), transparent 60%)' }} />
          <div className="glow-orb" style={{ top: '-30%', right: '10%', width: '420px', height: '320px', background: 'radial-gradient(ellipse, rgba(124,58,237,0.20), transparent 60%)' }} />
        </>
      )}
      {nodes && <div className="absolute inset-0 opacity-60"><NetworkNodes density={variant === 'hero' ? 'high' : 'medium'} /></div>}
      <div className="noise-overlay" />
    </div>
  );
}
